import React from "react";
import { ShieldCheck, Award, Lock, BadgeCheck, Cloud, Landmark, Sparkles } from "lucide-react";

const ITEMS = [
  { Icon: Award, k: "ISO 9001", v: "Quality" },
  { Icon: ShieldCheck, k: "ISO 27001", v: "Info Security" },
  { Icon: Lock, k: "ISO 27701", v: "Privacy" },
  { Icon: BadgeCheck, k: "GDPR", v: "Compliant" },
  { Icon: Cloud, k: "AWS Cloud", v: "Hosted" },
  { Icon: Landmark, k: "Companies House", v: "UK Authorised" },
];

export default function TrustedBy() {
  return (
    <section className="relative py-10 md:py-14" data-testid="trusted-by">
      <div className="container-cv">
        {/* Ribbon, dark primary band with accent flag tails on either end */}
        <div className="relative">
          {/* Left & right tail "ribbon ends" creating the bow-tie effect */}
          <div className="hidden md:block absolute -left-3 top-1/2 -translate-y-1/2 z-0">
            <div className="h-0 w-0 border-t-[22px] border-b-[22px] border-r-[14px] border-t-transparent border-b-transparent border-r-primary/90" />
          </div>
          <div className="hidden md:block absolute -right-3 top-1/2 -translate-y-1/2 z-0">
            <div className="h-0 w-0 border-t-[22px] border-b-[22px] border-l-[14px] border-t-transparent border-b-transparent border-l-primary/90" />
          </div>

          {/* Main ribbon body */}
          <div
            className="relative rounded-xl bg-primary text-primary-foreground overflow-hidden shadow-[0_18px_40px_-18px_rgba(14,58,95,0.45)]"
            style={{
              backgroundImage:
                "linear-gradient(90deg, hsl(207 74% 18%) 0%, hsl(207 74% 21%) 25%, hsl(207 74% 24%) 75%, hsl(207 74% 18%) 100%)",
            }}
          >
            {/* Subtle accent dot-grid */}
            <div className="absolute inset-0 bg-dotgrid opacity-[0.06] pointer-events-none" />
            {/* Top accent rim */}
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent/50 to-transparent pointer-events-none" />

            <div className="relative px-6 md:px-10 py-6 md:py-7 grid lg:grid-cols-12 gap-6 lg:gap-8 items-center">
              <div className="lg:col-span-3">
                <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-accent">
                  <Sparkles className="h-3 w-3" /> Trust ribbon
                </span>
                <div className="mt-2 font-display text-xl md:text-2xl font-bold text-white leading-tight tracking-tight">
                  Certified, <span className="text-accent">Compliant</span> &amp; Trusted
                </div>
                <p className="mt-1.5 text-xs text-white/65 leading-relaxed">
                  Independently audited security &amp; compliance posture.
                </p>
              </div>
              <div className="lg:col-span-9">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
                  {ITEMS.map(({ Icon, k, v }, i) => (
                    <div
                      key={i}
                      data-testid={`hero-trust-${k.toLowerCase().replace(/\s+/g, "-")}`}
                      className="group flex items-center gap-2.5 rounded-lg border border-white/10 bg-white/[0.05] backdrop-blur-sm p-2.5 hover:border-accent/50 hover:bg-white/[0.08] transition-all"
                    >
                      <div className="h-8 w-8 rounded-md bg-accent/15 text-accent grid place-items-center shrink-0">
                        <Icon className="h-4 w-4" strokeWidth={2} />
                      </div>
                      <div className="min-w-0">
                        <div className="text-[11px] font-bold text-white leading-tight truncate">{k}</div>
                        <div className="text-[9px] text-white/60 leading-tight">{v}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
